import {
  ConfirmationListTable,
  ConfirmationListTableFilters,
  useDefaultRltConfirmationListRequest,
} from "@/services/backend/rlt/confirmations/components/confirmation-list-table";
import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import { CreateConfirmationButton } from "@/services/backend/rlt/confirmations/components/create-confirmation-dialog";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";

export function ConfirmationIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();

  const [request, setRequest] = useState(
    useDefaultRltConfirmationListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Auftragsbestätigungen")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <ConfirmationListTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <CreateConfirmationButton
              processId={processId!}
              onCreated={(id) => navigate(id)}
            />
          </div>
          <ConfirmationListTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
